import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { Section } from './ui/Section';
const bonos = [{
  num: 'BONO 1',
  name: 'Mapa de Rutas EBI',
  desc: 'Calendario anual con secuencia semanal para los 3 espacios curriculares. Tu año completo organizado en una sola hoja.',
  val: '$120 UYU'
}, {
  num: 'BONO 2',
  name: 'Planificador Semanal Editable',
  desc: 'Plantilla lista para completar cada lunes. Formato PDF editable. Sin armar nada desde cero.',
  val: '$100 UYU'
}, {
  num: 'BONO 3',
  name: 'Guía de Comunicación con Familias',
  desc: 'Mensajes listos para WhatsApp: avisos, logros, citaciones, comunicados. Copiás y enviás.',
  val: '$80 UYU'
}, {
  num: 'BONO 4',
  name: 'Kit Diversidad en el Aula',
  desc: 'Material adaptado para cuando tenés distintos ritmos y niveles de logro en el mismo grupo.',
  val: '$80 UYU'
}, {
  num: 'BONO 5',
  name: 'Banco de Juegos Pedagógicos',
  desc: '20 dinámicas listas para usar en los 3 espacios curriculares. Aprendizaje activo sin preparación extra.',
  val: '$70 UYU'
}, {
  num: 'BONO 6',
  name: 'Sistema Clase Lista',
  desc: 'El método de 3 pasos para entrar al aula con todo resuelto. Siempre.',
  val: '$50 UYU'
}];
export const Bonos = () => {
  return <Section background="cream" data-id="element-18">
      <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-19">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-100 text-amber-600 mb-6" data-id="element-20">
          <Gift className="w-8 h-8" data-id="element-21" />
        </div>
        <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900 mb-4" data-id="element-22">
          🎁 6 BONOS ESTRATÉGICOS
        </h2>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-12" data-id="element-23">
        {bonos.map((bono, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.1
      }} className="bg-white rounded-2xl p-6 shadow-sm border border-amber-100 flex flex-col relative overflow-hidden" data-id="element-24">
            <div className="absolute top-0 right-0 bg-amber-100 text-amber-800 text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-25">
              {bono.val} → GRATIS
            </div>
            <div className="text-amber-600 font-bold text-sm mb-2 mt-2" data-id="element-26">
              {bono.num}
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-27">
              {bono.name}
            </h3>
            <p className="text-stone-600 text-sm font-medium leading-relaxed mb-4 flex-grow" data-id="element-28">
              {bono.desc}
            </p>
          </motion.div>)}
      </div>

      <div className="max-w-2xl mx-auto bg-amber-50 rounded-2xl p-6 md:p-8 text-center border border-amber-200" data-id="element-29">
        <p className="text-stone-600 font-medium mb-2" data-id="element-30">
          Valor total de los 6 bonos:{' '}
          <span className="line-through" data-id="element-31">$500 UYU</span>
        </p>
        <p className="text-2xl md:text-3xl font-extrabold text-amber-700" data-id="element-32">
          Incluidos con tu Kit + Bonos
        </p>
      </div>
    </Section>;
};